/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CostInputs */



/**
* | output |
* | --- |
* | "Cost" |
*
* @param {CostInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cost = /** @type {((inputs?: CostInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CostInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coût")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kosten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Costo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расходы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Costo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("料金")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लागत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Custo")
	return /** @type {LocalizedString} */ ("Cost")
});